var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReferWithText(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 277.065,
    height: 222.152,
    viewBox: "0 0 277.065 222.152",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cca086"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.569,
    stopColor: "#d1b29d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 12.698,
    y1: -0.226,
    x2: 13.576,
    y2: -0.226,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 12.871,
    y1: -0.651,
    x2: 13.749,
    y2: -0.651,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 1.947,
    y1: 0.194,
    x2: 2.722,
    y2: 0.194,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_664",
    "data-name": "Rectangle 664",
    width: 114.93,
    height: 83.184,
    fill: "none"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_82",
    x: 45.633,
    y: 17.731,
    width: 33.624,
    height: 33.624,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1659",
    "data-name": "Group 1659",
    transform: "translate(-737.853 -25.949)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1658",
    "data-name": "Group 1658",
    transform: "translate(737.853 25.949)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1084",
    "data-name": "Group 1084",
    transform: "translate(22.923 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1078",
    "data-name": "Group 1078",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1075",
    "data-name": "Group 1075",
    transform: "translate(79.838 6.376)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1074",
    "data-name": "Group 1074",
    transform: "translate(0 91.827)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_628",
    "data-name": "Rectangle 628",
    width: 86.899,
    height: 29.683,
    transform: "translate(26.884 0)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_816",
    "data-name": "Path 816",
    d: "M1547.247,387.469h0v29.925a30.956,30.956,0,1,1-26.377,47.157,23.674,23.674,0,0,0-20.156-11.29h0a12.511,12.511,0,0,0-11.887,16.552,62.146,62.146,0,0,0,58.421,41.478h0a61.911,61.911,0,1,0,0-123.821Z",
    transform: "translate(-1434.855 -387.469)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_818",
    "data-name": "Path 818",
    d: "M1434.141,409.563",
    transform: "translate(-1417.991 -394.371)",
    fill: "none",
    stroke: "#99c700",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1070",
    "data-name": "Group 1070",
    transform: "translate(15.735 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_819",
    "data-name": "Path 819",
    d: "M1505.225,387.469a23.549,23.549,0,0,1-46.606,0h-25.081V511.292H1530.6V387.469Z",
    transform: "translate(-1433.538 -387.469)",
    fill: "#2e2e2d"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Union_1",
    "data-name": "Union 1",
    d: "M-202.867-132.178v-58.089h96.81v58.089Zm96.825-28.164v-29.925a61.348,61.348,0,0,1,27.86,6.67l-15.033,26.039a30.829,30.829,0,0,0-12.828-2.784Z",
    transform: "translate(218.602 190.267)",
    fill: "#2e2e2d",
    stroke: "rgba(0,0,0,0)",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1072",
    "data-name": "Group 1072",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_823",
    "data-name": "Path 823",
    d: "M1427.29,387.469a16.637,16.637,0,0,0-16.637,16.637v40.285h29.684V387.469Z",
    transform: "translate(-1410.653 -387.469)",
    fill: "#2e2e2d"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_630",
    "data-name": "Rectangle 630",
    width: 97.067,
    height: 27.996,
    transform: "translate(15.735 38.403)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_825",
    "data-name": "Path 825",
    d: "M1559.519,520.962h-11.934a16.018,16.018,0,0,0-16.018,16.017h0A16.017,16.017,0,0,0,1547.584,553h11.935a16.016,16.016,0,0,0,16.016-16.016h0a16.017,16.017,0,0,0-16.017-16.017Z",
    transform: "translate(-1448.428 -429.174)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_826",
    "data-name": "Path 826",
    d: "M1499.808,255.3l-7.6-1.068c-15.518-2.182-29.836,7.553-31.815,21.634l-8.473,60.261,64.026,9,8.474-60.259C1526.4,270.785,1515.327,257.479,1499.808,255.3Z",
    transform: "translate(-1423.547 -253.923)",
    fill: "#e9edf1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_827",
    "data-name": "Path 827",
    d: "M1453.295,312.223a9.261,9.261,0,0,0,7.882,10.461l2.579-18.34A9.261,9.261,0,0,0,1453.295,312.223Z",
    transform: "translate(-1423.947 -269.644)",
    fill: "url(#linear-gradient-4)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_828",
    "data-name": "Path 828",
    d: "M1547.461,315.64l-2.579,18.34a9.261,9.261,0,1,0,2.579-18.341Z",
    transform: "translate(-1452.588 -273.201)",
    fill: "url(#linear-gradient-5)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_631",
    "data-name": "Rectangle 631",
    width: 73.013,
    height: 56.574,
    rx: 28.287,
    transform: "translate(33.092 77.696) rotate(-81.997)",
    fill: "url(#linear-gradient-6)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_73",
    "data-name": "Ellipse 73",
    cx: 1.868,
    cy: 1.868,
    rx: 1.868,
    ry: 1.868,
    transform: "translate(55.59 40.704)",
    fill: "#2e2e2d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_74",
    "data-name": "Ellipse 74",
    cx: 1.868,
    cy: 1.868,
    rx: 1.868,
    ry: 1.868,
    transform: "translate(75.081 43.444)",
    fill: "#2e2e2d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_829",
    "data-name": "Path 829",
    d: "M15.435,1.834,2.6.031A2.262,2.262,0,0,0,.113,1.466,2.173,2.173,0,0,0,1.868,4.31L14.7,6.112a2.263,2.263,0,0,0,2.489-1.435,2.173,2.173,0,0,0-1.753-2.843Z",
    transform: "translate(43.997 34.197) rotate(-17)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_830",
    "data-name": "Path 830",
    d: "M15.246,4.394,3,.145a2.262,2.262,0,0,0-2.719.925A2.173,2.173,0,0,0,1.456,4.2L13.7,8.447a2.264,2.264,0,0,0,2.718-.928,2.176,2.176,0,0,0-1.173-3.126Z",
    transform: "translate(73.538 34.093) rotate(4.012)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_831",
    "data-name": "Path 831",
    d: "M1460.17,340.121l-5.27-.742a.4.4,0,0,1-.238-.657l5.925-6.569a.4.4,0,0,0-.24-.657l-6.1-.858a.4.4,0,0,0-.406.208l-5.411,10.257a.4.4,0,0,0,.3.577l4.423.622a.4.4,0,0,1,.3.562l-3.591,7.58a.4.4,0,0,0,.641.446l9.9-10.1a.4.4,0,0,0-.228-.672Z",
    transform: "translate(-1422.441 -277.885)",
    fill: "#fbae47"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_832",
    "data-name": "Path 832",
    d: "M1462.665,322.54a3.592,3.592,0,1,0-1,7.113",
    transform: "translate(-1425.624 -275.345)",
    fill: "none",
    stroke: "#faad47",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_833",
    "data-name": "Path 833",
    d: "M1505.3,256.632l-10.648-1.5a25.005,25.005,0,0,0-28.16,21.217l-1.548,11.006,9.223,1.3,2.78-10.578.042,10.972,7.022.988,2.8-13.915-.668,14.214,8.468,1.191,1.351-7.072.487,7.33,16.25,2.284.406-18.144,2.414,18.54,9.455,1.33,1.547-11.007A25,25,0,0,0,1505.3,256.632Z",
    transform: "translate(-1427.614 -254.228)",
    fill: "#e9edf1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1605",
    "data-name": "Group 1605",
    transform: "translate(7.492 11.831)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1604",
    "data-name": "Group 1604",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1603",
    "data-name": "Group 1603"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1602",
    "data-name": "Group 1602",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2718",
    "data-name": "Path 2718",
    d: "M86.071,75.547A4.074,4.074,0,0,0,79,72.637a4.074,4.074,0,0,0-7.6.845l-2.818-.4a10.322,10.322,0,0,0,20.442,2.874Z",
    transform: "translate(-22.239 -22.858)",
    fill: "#ff00a2"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1077",
    "data-name": "Group 1077"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_835",
    "data-name": "Path 835",
    d: "M1106.3,521.746a5.263,5.263,0,0,0-5.174,5.35V548.4a5.264,5.264,0,0,0,5.174,5.35h87.693c17.1,0,30.956-14.331,30.956-32.009Z",
    transform: "translate(-1035.013 -331.727)",
    fill: "#f3d1a5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_635",
    "data-name": "Rectangle 635",
    width: 86.899,
    height: 29.683,
    transform: "translate(26.883 98.204)",
    fill: "#f3d1a5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_838",
    "data-name": "Path 838",
    d: "M1025.625,387.469h-4.789a15.863,15.863,0,0,0-15.863,15.863V511.418c-.009-.032,31.072-.433,30.956,0V397.773a10.3,10.3,0,0,0-10.3-10.3Z",
    transform: "translate(-1004.974 -289.265)",
    fill: "#f3d1a5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_839",
    "data-name": "Path 839",
    d: "M1161.237,387.469h-4.789a10.3,10.3,0,0,0-10.3,10.3v98.04a15.478,15.478,0,0,0,15.478,15.478h0a15.478,15.478,0,0,0,15.478-15.478V403.332A15.863,15.863,0,0,0,1161.237,387.469Z",
    transform: "translate(-1049.078 -289.265)",
    fill: "#f3d1a5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_840",
    "data-name": "Path 840",
    d: "M1099.545,387.469a23.548,23.548,0,0,1-46.606,0h-25.081V511.292h97.067V387.469Z",
    transform: "translate(-1012.123 -289.265)",
    fill: "#ea088b"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1076",
    "data-name": "Group 1076",
    transform: "translate(23.33)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_841",
    "data-name": "Path 841",
    d: "M1039.6,325.133a9.184,9.184,0,0,0,10.008,8.28l-1.728-18.287A9.184,9.184,0,0,0,1039.6,325.133Z",
    transform: "translate(-1038.474 -268.567)",
    fill: "#f3d1a5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_842",
    "data-name": "Path 842",
    d: "M1132.666,307.452l1.727,18.287a9.184,9.184,0,1,0-1.727-18.287Z",
    transform: "translate(-1068.831 -266.157)",
    fill: "#f3d1a5"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_75",
    "data-name": "Ellipse 75",
    cx: 16.822,
    cy: 16.822,
    r: 16.822,
    transform: "translate(32.577 16.933)",
    fill: "#f05a26"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_76",
    "data-name": "Ellipse 76",
    cx: 16.822,
    cy: 16.822,
    r: 16.822,
    transform: "translate(5.797 20.269)",
    fill: "#f05a26"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_636",
    "data-name": "Rectangle 636",
    width: 55.769,
    height: 75.152,
    rx: 27.884,
    transform: "translate(5.821 13.445) rotate(-5.398)",
    fill: "#f3d1a5"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_77",
    "data-name": "Ellipse 77",
    cx: 13.086,
    cy: 13.086,
    rx: 13.086,
    ry: 13.086,
    transform: "translate(21.1)",
    fill: "#f05a26"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_78",
    "data-name": "Ellipse 78",
    cx: 12.3,
    cy: 12.3,
    r: 12.3,
    transform: "matrix(0.637, -0.77, 0.77, 0.637, 0, 24.256)",
    fill: "#f05a26"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_79",
    "data-name": "Ellipse 79",
    cx: 10.824,
    cy: 10.824,
    r: 10.824,
    transform: "translate(40.423 10.606) rotate(-14.592)",
    fill: "#f05a26"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_80",
    "data-name": "Ellipse 80",
    cx: 1.852,
    cy: 1.852,
    rx: 1.852,
    ry: 1.852,
    transform: "translate(25.743 48.115)",
    fill: "#2e2e2d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_81",
    "data-name": "Ellipse 81",
    cx: 1.852,
    cy: 1.852,
    rx: 1.852,
    ry: 1.852,
    transform: "translate(45.176 46.278)",
    fill: "#2e2e2d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_843",
    "data-name": "Path 843",
    d: "M1108.256,305.175l-6.981-2.332a2.152,2.152,0,1,0-1.364,4.082l6.981,2.332a2.152,2.152,0,1,0,1.364-4.082Z",
    transform: "translate(-1057.504 -267.753)",
    fill: "#f05a26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_844",
    "data-name": "Path 844",
    d: "M9.276.01,1.95.7a2.152,2.152,0,0,0,.4,4.285l7.327-.693A2.152,2.152,0,0,0,9.276.01Z",
    transform: "translate(19.451 39.051) rotate(-17)",
    fill: "#f05a26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_845",
    "data-name": "Path 845",
    d: "M1080.508,344.585a10.424,10.424,0,1,0,20.755-1.961Z",
    transform: "translate(-1051.902 -277.158)",
    fill: "#2e2e2d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_846",
    "data-name": "Path 846",
    d: "M1111.012,337.628l-10.8-2.3a3.228,3.228,0,1,0-1.342,6.315l10.8,2.3a3.228,3.228,0,1,0,1.342-6.315Z",
    transform: "translate(-1056.84 -277.395)",
    fill: "#f05a26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_847",
    "data-name": "Path 847",
    d: "M1086.9,337.408h0a3.237,3.237,0,0,0-4.355-1.367l-9.786,5.11a3.229,3.229,0,1,0,2.988,5.725l9.786-5.11A3.238,3.238,0,0,0,1086.9,337.408Z",
    transform: "translate(-1048.938 -277.81)",
    fill: "#f05a26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_848",
    "data-name": "Path 848",
    d: "M1044.113,301.888a9.185,9.185,0,0,0,10.008,8.28l-1.728-18.287A9.185,9.185,0,0,0,1044.113,301.888Z",
    transform: "translate(-1040.518 -261.305)",
    fill: "#f05a26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_849",
    "data-name": "Path 849",
    d: "M1123.88,285.463l1.728,18.287a9.184,9.184,0,1,0-1.728-18.287Z",
    transform: "translate(-1065.451 -259.287)",
    fill: "#f05a26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_850",
    "data-name": "Path 850",
    d: "M1100.014,278.83l-48.766,4.607a6.131,6.131,0,1,0,1.153,12.207l48.766-4.607a6.131,6.131,0,0,0-1.153-12.207Z",
    transform: "translate(-1041.025 -257.219)",
    fill: "#faad47"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -46.25, 0)",
    filter: "url(#Ellipse_82)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_82-2",
    "data-name": "Ellipse 82",
    cx: 7.812,
    cy: 7.812,
    r: 7.812,
    transform: "translate(54.63 23.73)",
    fill: "#f05a26"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_851",
    "data-name": "Path 851",
    d: "M1106.035,327.223l.371,3.943a21.687,21.687,0,0,1-19.494,23.562l-5.656.535a21.687,21.687,0,0,1-23.563-19.494l-.371-3.943-3.6.34,2.09,22.128a16.03,16.03,0,0,0,17.467,14.451l23.938-2.261a16.03,16.03,0,0,0,14.452-17.467l-2.091-22.129Z",
    transform: "translate(-1043.534 -272.24)",
    fill: "#f05a26"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_852",
    "data-name": "Path 852",
    d: "M1077.616,510.187l32.519-44.076a1.534,1.534,0,0,0-1.234-2.444H1088.29a1.533,1.533,0,0,1-1.272-2.392l19.181-28.388a1.533,1.533,0,0,0-1.272-2.392h-23.87a1.533,1.533,0,0,0-1.442,1.013l-15.222,42.259a1.534,1.534,0,0,0,1.445,2.051h17.3a1.534,1.534,0,0,1,1.464,1.99l-9.685,31.009a1.534,1.534,0,0,0,2.7,1.369Z",
    transform: "translate(-1023.509 -302.707)",
    fill: "#faad47"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_853",
    "data-name": "Path 853",
    d: "M1028.46,409.563",
    transform: "translate(-1012.311 -296.168)",
    fill: "none",
    stroke: "#99c700",
    strokeMiterlimit: 10,
    strokeWidth: 5
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1086",
    "data-name": "Group 1086",
    transform: "translate(0 66.107)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_640",
    "data-name": "Rectangle 640",
    d: "M11.019,0H52.3a11.019,11.019,0,0,1,0,22.038H11.019A11.019,11.019,0,0,1,11.019,0Z",
    transform: "translate(0 4.561)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1088",
    "data-name": "Group 1088",
    transform: "translate(185.263 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Polygon_8",
    "data-name": "Polygon 8",
    d: "M7.421,0l7.421,32.334H0Z",
    transform: "matrix(0.358, -0.934, 0.934, 0.358, 0, 13.856)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_869",
    "data-name": "Path 869",
    d: "M11.131,0H44A11.131,11.131,0,0,1,55.127,11.131v7.421A11.131,11.131,0,0,1,44,29.684H11.131A11.131,11.131,0,0,1,0,18.552V11.131A11.131,11.131,0,0,1,11.131,0Z",
    transform: "translate(13.512 1.06)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1324",
    "data-name": "Group 1324",
    transform: "translate(203.656 5.808)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2974",
    "data-name": "Path 2974",
    d: "M.185,2.378a.178.178,0,0,1-.13-.055A.178.178,0,0,1,0,2.193a.186.186,0,0,1,.008-.059L1.881-3.223a.43.43,0,0,1,.126-.193A.36.36,0,0,1,2.259-3.5H4.081a.36.36,0,0,1,.252.084.43.43,0,0,1,.126.193L6.331,2.134a.186.186,0,0,1,.008.059.186.186,0,0,1-.185.185H4.6a.312.312,0,0,1-.327-.21l-.2-.554H2.267l-.2.554a.312.312,0,0,1-.327.21Zm3.459-2.4L3.166-1.586,2.7-.024Zm3.384,2.4A.229.229,0,0,1,6.8,2.151V-3.273a.218.218,0,0,1,.067-.16.218.218,0,0,1,.16-.067H8.355a.367.367,0,0,1,.344.193L10.118-.981V-3.273a.218.218,0,0,1,.067-.16.218.218,0,0,1,.16-.067h1.52a.218.218,0,0,1,.16.067.218.218,0,0,1,.067.16V2.151a.229.229,0,0,1-.227.227H10.538a.35.35,0,0,1-.218-.059.571.571,0,0,1-.126-.134L8.774.043V2.151a.229.229,0,0,1-.227.227Zm6.213,0a.229.229,0,0,1-.227-.227V-3.273a.218.218,0,0,1,.067-.16.218.218,0,0,1,.16-.067H15.66a3.545,3.545,0,0,1,1.419.269,2.31,2.31,0,0,1,.991.789,2.244,2.244,0,0,1,.395,1.251q.017.47.017.638T18.464.06A2.209,2.209,0,0,1,17.679,1.8a3.107,3.107,0,0,1-1.977.579ZM15.66.74a.659.659,0,0,0,.474-.172.722.722,0,0,0,.2-.508q.017-.244.017-.63t-.017-.621a.672.672,0,0,0-.214-.5.744.744,0,0,0-.5-.168h-.5V.74Zm5.357,1.637a.229.229,0,0,1-.227-.227V-3.273a.218.218,0,0,1,.067-.16.218.218,0,0,1,.16-.067H22.73a.218.218,0,0,1,.16.067.218.218,0,0,1,.067.16V2.151a.229.229,0,0,1-.227.227Z",
    transform: "translate(10.303 5)",
    fill: "#ec008c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2975",
    "data-name": "Path 2975",
    d: "M3.018,2.8a3.228,3.228,0,0,1-2.04-.579A2.194,2.194,0,0,1,.188.492Q.18.265.18-.255t.008-.764a2.05,2.05,0,0,1,.8-1.658,3.309,3.309,0,0,1,2.032-.567,4.193,4.193,0,0,1,1.511.252,2.374,2.374,0,0,1,1.008.68,1.529,1.529,0,0,1,.369.94.178.178,0,0,1-.055.13.178.178,0,0,1-.13.055H3.866a.3.3,0,0,1-.244-.092,1.218,1.218,0,0,0-.076-.1.559.559,0,0,0-.206-.155.733.733,0,0,0-.323-.067.578.578,0,0,0-.647.63q-.008.227-.008.705T2.372.45q.025.714.68.714a.854.854,0,0,0,.525-.143A.532.532,0,0,0,3.765.568V.559H3.371a.218.218,0,0,1-.16-.067.218.218,0,0,1-.067-.16V-.6a.218.218,0,0,1,.067-.16.218.218,0,0,1,.16-.067H5.68a.218.218,0,0,1,.16.067.218.218,0,0,1,.067.16V.492a2.137,2.137,0,0,1-.365,1.259,2.231,2.231,0,0,1-1.016.785A3.981,3.981,0,0,1,3.018,2.8Zm3.871-.084a.229.229,0,0,1-.227-.227V-2.934a.218.218,0,0,1,.067-.16.218.218,0,0,1,.16-.067H11.2a.218.218,0,0,1,.16.067.218.218,0,0,1,.067.16V-1.75a.218.218,0,0,1-.067.16.218.218,0,0,1-.16.067H8.677v.529h2.334a.218.218,0,0,1,.16.067.218.218,0,0,1,.067.16V.324a.218.218,0,0,1-.067.16.218.218,0,0,1-.16.067H8.677V1.08h2.586a.229.229,0,0,1,.227.227V2.491a.229.229,0,0,1-.227.227Zm6.9,0a.229.229,0,0,1-.227-.227V-1.355H12.17a.218.218,0,0,1-.16-.067.218.218,0,0,1-.067-.16V-2.934a.218.218,0,0,1,.067-.16.218.218,0,0,1,.16-.067h4.92a.218.218,0,0,1,.16.067.218.218,0,0,1,.067.16v1.352a.218.218,0,0,1-.067.16.218.218,0,0,1-.16.067H15.7V2.491a.229.229,0,0,1-.227.227Zm7.507.84a.229.229,0,0,1-.227-.227V2.751a2.649,2.649,0,0,1-1.482-.617,1.551,1.551,0,0,1-.533-1.121A.186.186,0,0,1,19.24.828h1.6a.5.5,0,0,1,.189.029A.713.713,0,0,1,21.2.971a.969.969,0,0,0,.621.193,1.363,1.363,0,0,0,.458-.063q.172-.063.172-.172,0-.151-.227-.231a5.048,5.048,0,0,0-.856-.164Q19.2.249,19.2-1.313a1.652,1.652,0,0,1,.508-1.218,2.5,2.5,0,0,1,1.364-.655v-.588a.218.218,0,0,1,.067-.16A.218.218,0,0,1,21.3-4h1.016a.218.218,0,0,1,.16.067.218.218,0,0,1,.067.16v.613a2.812,2.812,0,0,1,.978.39,2.165,2.165,0,0,1,.638.613,1.33,1.33,0,0,1,.239.651.178.178,0,0,1-.055.13.169.169,0,0,1-.122.055H22.54a.471.471,0,0,1-.185-.029.594.594,0,0,1-.151-.1.66.66,0,0,0-.445-.151q-.4,0-.4.235,0,.126.2.21a3.163,3.163,0,0,0,.735.151,5.18,5.18,0,0,1,1.348.327,1.573,1.573,0,0,1,.739.584,1.691,1.691,0,0,1,.231.919,1.628,1.628,0,0,1-.567,1.264,2.88,2.88,0,0,1-1.5.659V3.33a.229.229,0,0,1-.227.227ZM27.7,2.818a3.8,3.8,0,0,1-1.461-.252,2.055,2.055,0,0,1-.911-.68,1.691,1.691,0,0,1-.323-.949.186.186,0,0,1,.185-.185h1.7a.368.368,0,0,1,.3.134.93.93,0,0,0,.227.231.559.559,0,0,0,.294.063.512.512,0,0,0,.365-.139A.5.5,0,0,0,28.225.66.516.516,0,0,0,28.086.3a.482.482,0,0,0-.374-.151.625.625,0,0,0-.227.034.668.668,0,0,0-.168.1.249.249,0,0,1-.143.067H25.5a.178.178,0,0,1-.13-.055.178.178,0,0,1-.055-.13l.336-3.04a.3.3,0,0,1,.109-.214.347.347,0,0,1,.218-.071h3.753a.218.218,0,0,1,.16.067.218.218,0,0,1,.067.16V-1.75a.218.218,0,0,1-.067.16.218.218,0,0,1-.16.067H27.284l-.067.6a1.548,1.548,0,0,1,.474-.223,2.663,2.663,0,0,1,.651-.063,2.069,2.069,0,0,1,.991.252,2.078,2.078,0,0,1,.764.7,1.745,1.745,0,0,1,.294.982,1.908,1.908,0,0,1-.306,1.05,2.117,2.117,0,0,1-.915.764A3.429,3.429,0,0,1,27.7,2.818ZM33.615,2.8a2.808,2.808,0,0,1-1.889-.6A2.206,2.206,0,0,1,30.979.652q-.025-.344-.025-.882t.025-.9a2.167,2.167,0,0,1,.365-1.1,2.189,2.189,0,0,1,.907-.747,3.191,3.191,0,0,1,1.364-.273,3.191,3.191,0,0,1,1.364.273,2.189,2.189,0,0,1,.907.747,2.167,2.167,0,0,1,.365,1.1q.025.353.025.9t-.025.882A2.206,2.206,0,0,1,35.5,2.205,2.808,2.808,0,0,1,33.615,2.8Zm0-1.646q.42,0,.453-.546.017-.244.017-.848t-.017-.84q-.034-.537-.453-.546-.42.008-.453.546-.017.453-.017.84,0,.361.017.848Q33.2,1.156,33.615,1.156ZM37.293.467A.218.218,0,0,1,37.134.4a.218.218,0,0,1-.067-.16V-2.934a.218.218,0,0,1,.067-.16.218.218,0,0,1,.16-.067h1.461a.218.218,0,0,1,.16.067.218.218,0,0,1,.067.16V.24a.218.218,0,0,1-.067.16.218.218,0,0,1-.16.067Zm0,2.25a.229.229,0,0,1-.227-.227V1.03A.229.229,0,0,1,37.293.8h1.461a.229.229,0,0,1,.227.227V2.491a.229.229,0,0,1-.227.227Z",
    transform: "translate(2.2 13.827)",
    fill: "#ec008c"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Polygon_7",
    "data-name": "Polygon 7",
    d: "M7.421,0l7.421,32.334H0Z",
    transform: "translate(68.739 0.255) rotate(66.997)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "I_GET_50_",
    "data-name": "I GET $50!",
    d: "M1.109-6.015a.22.22,0,0,1-.161-.068A.22.22,0,0,1,.88-6.244v-5.479a.22.22,0,0,1,.068-.161.22.22,0,0,1,.161-.068h1.73A.22.22,0,0,1,3-11.884a.22.22,0,0,1,.068.161v5.479A.22.22,0,0,1,3-6.083a.22.22,0,0,1-.161.068Zm7.175.085a3.261,3.261,0,0,1-2.061-.585,2.216,2.216,0,0,1-.8-1.747q-.008-.229-.008-.755t.008-.772a2.071,2.071,0,0,1,.806-1.675,3.342,3.342,0,0,1,2.052-.572,4.235,4.235,0,0,1,1.527.254,2.4,2.4,0,0,1,1.018.687,1.544,1.544,0,0,1,.373.95.179.179,0,0,1-.055.131.179.179,0,0,1-.131.055H9.141a.3.3,0,0,1-.246-.093,1.231,1.231,0,0,0-.076-.106.565.565,0,0,0-.208-.157.74.74,0,0,0-.327-.068.584.584,0,0,0-.653.636q-.008.229-.008.712t.008.729q.025.721.687.721a.862.862,0,0,0,.53-.144.537.537,0,0,0,.191-.458v-.008h-.4a.22.22,0,0,1-.161-.068.22.22,0,0,1-.068-.161v-.941a.22.22,0,0,1,.068-.161.22.22,0,0,1,.161-.068h2.332a.22.22,0,0,1,.161.068.22.22,0,0,1,.068.161v1.1a2.159,2.159,0,0,1-.369,1.272A2.253,2.253,0,0,1,9.806-6.2,4.021,4.021,0,0,1,8.284-5.93Zm3.91-.085a.22.22,0,0,1-.161-.068.22.22,0,0,1-.068-.161v-5.479a.22.22,0,0,1,.068-.161.22.22,0,0,1,.161-.068h4.351a.22.22,0,0,1,.161.068.22.22,0,0,1,.068.161v1.2a.22.22,0,0,1-.068.161.22.22,0,0,1-.161.068H14v.534h2.358a.22.22,0,0,1,.161.068.22.22,0,0,1,.068.161v1.1a.22.22,0,0,1-.068.161.22.22,0,0,1-.161.068H14v.534h2.612a.22.22,0,0,1,.161.068.22.22,0,0,1,.068.161v1.2a.22.22,0,0,1-.068.161.22.22,0,0,1-.161.068Zm6.971,0A.22.22,0,0,1,19-6.083a.22.22,0,0,1-.068-.161v-3.884H17.528a.22.22,0,0,1-.161-.068.22.22,0,0,1-.068-.161v-1.365a.22.22,0,0,1,.068-.161.22.22,0,0,1,.161-.068H22.5a.22.22,0,0,1,.161.068.22.22,0,0,1,.068.161v1.365a.22.22,0,0,1-.068.161.22.22,0,0,1-.161.068H21.09v3.884a.22.22,0,0,1-.068.161.22.22,0,0,1-.161.068Zm7.582.848a.22.22,0,0,1-.161-.068.22.22,0,0,1-.068-.161v-.585a2.676,2.676,0,0,1-1.5-.623,1.567,1.567,0,0,1-.539-1.132.179.179,0,0,1,.055-.131.179.179,0,0,1,.131-.055h1.611a.51.51,0,0,1,.191.03.72.72,0,0,1,.174.114.979.979,0,0,0,.628.2,1.377,1.377,0,0,0,.462-.064q.174-.064.174-.174,0-.153-.229-.233a5.1,5.1,0,0,0-.865-.165q-2.188-.288-2.188-1.866a1.669,1.669,0,0,1,.513-1.23,2.521,2.521,0,0,1,1.378-.662v-.594a.22.22,0,0,1,.068-.161.22.22,0,0,1,.161-.068h1.026a.22.22,0,0,1,.161.068.22.22,0,0,1,.068.161v.619a2.84,2.84,0,0,1,.988.394,2.187,2.187,0,0,1,.645.619,1.344,1.344,0,0,1,.242.657.179.179,0,0,1-.055.131.17.17,0,0,1-.123.055H28a.476.476,0,0,1-.187-.03.6.6,0,0,1-.153-.106.666.666,0,0,0-.449-.153q-.407,0-.407.237,0,.127.2.212a3.194,3.194,0,0,0,.742.153,5.232,5.232,0,0,1,1.361.331,1.589,1.589,0,0,1,.746.589,1.708,1.708,0,0,1,.233.929,1.644,1.644,0,0,1-.572,1.276A2.909,2.909,0,0,1,28-5.99V-5.4a.22.22,0,0,1-.068.161.22.22,0,0,1-.161.068Zm6.471-.746a3.833,3.833,0,0,1-1.476-.254,2.076,2.076,0,0,1-.92-.687,1.708,1.708,0,0,1-.327-.958.179.179,0,0,1,.055-.131A.179.179,0,0,1,30.682-8H32.4a.372.372,0,0,1,.305.136.94.94,0,0,0,.229.233.565.565,0,0,0,.3.064.517.517,0,0,0,.369-.14.5.5,0,0,0,.148-.386.521.521,0,0,0-.14-.365.487.487,0,0,0-.377-.153A.631.631,0,0,0,33-8.576a.675.675,0,0,0-.17.1.251.251,0,0,1-.144.068H31a.179.179,0,0,1-.131-.055.179.179,0,0,1-.055-.131l.339-3.07a.3.3,0,0,1,.11-.216.35.35,0,0,1,.221-.072h3.791a.22.22,0,0,1,.161.068.22.22,0,0,1,.068.161v1.2a.22.22,0,0,1-.068.161.22.22,0,0,1-.161.068H32.794l-.068.6a1.564,1.564,0,0,1,.479-.225,2.69,2.69,0,0,1,.657-.064,2.09,2.09,0,0,1,1,.254,2.1,2.1,0,0,1,.772.7,1.763,1.763,0,0,1,.3.992,1.927,1.927,0,0,1-.31,1.06A2.138,2.138,0,0,1,34.7-6.2,3.463,3.463,0,0,1,33.218-5.913Zm5.971-.017a2.836,2.836,0,0,1-1.908-.6A2.228,2.228,0,0,1,36.526-8.1q-.025-.348-.025-.891t.025-.907a2.189,2.189,0,0,1,.369-1.107,2.211,2.211,0,0,1,.916-.755,3.223,3.223,0,0,1,1.378-.276,3.223,3.223,0,0,1,1.378.276,2.211,2.211,0,0,1,.916.755A2.189,2.189,0,0,1,41.852-9.9q.025.356.025.907t-.025.891A2.228,2.228,0,0,1,41.1-6.533,2.836,2.836,0,0,1,39.189-5.93Zm0-1.662q.424,0,.458-.551.017-.246.017-.857t-.017-.848q-.034-.543-.458-.551-.424.008-.458.551-.017.458-.017.848,0,.365.017.857Q38.765-7.593,39.189-7.593Zm3.715-.7a.22.22,0,0,1-.161-.068.22.22,0,0,1-.068-.161v-3.206a.22.22,0,0,1,.068-.161.22.22,0,0,1,.161-.068h1.476a.22.22,0,0,1,.161.068.22.22,0,0,1,.068.161v3.206a.22.22,0,0,1-.068.161.22.22,0,0,1-.161.068Zm0,2.273a.22.22,0,0,1-.161-.068.22.22,0,0,1-.068-.161V-7.72a.22.22,0,0,1,.068-.161.22.22,0,0,1,.161-.068h1.476a.22.22,0,0,1,.161.068.22.22,0,0,1,.068.161v1.476a.22.22,0,0,1-.068.161.22.22,0,0,1-.161.068Z",
    transform: "translate(8.812 24.833)",
    fill: "#ec008c"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_642",
    "data-name": "Rectangle 642",
    d: "M0,0H3.71A13.252,13.252,0,0,1,16.962,13.252h0A13.252,13.252,0,0,1,3.71,26.5H0Z",
    transform: "translate(758.93 148.763)",
    fill: "#cca086"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReferWithText);
export default __webpack_public_path__ + "static/media/refer-with-text.b5b02ef6a18cf35c8836ae881075273d.svg";
export { ForwardRef as ReactComponent };